import { sendGet, sendPost, sendPut } from './axios';

// eslint-disable-next-line import/prefer-default-export
export const addCustomerAddress = (payload: any) => sendPost('/order/customer-address', payload);
export const addCustomerEmail = (payload: any) => sendPost('/order/customer-email', payload);
export const createdOrderShopping = (payload: any) => sendPost('/order/shopping', payload);
export const getListComment = (idOrderDetail: any, payload: any) =>
  sendGet(`/order/${idOrderDetail}/list-comment`, payload);
export const sendComment = (idOrderDetail: any, payload: any) =>
  sendPut(`/order/${idOrderDetail}/add-comment`, payload);
export const sendReports = (idOrderDetail: any, payload: any) => sendPost(`/reports/${idOrderDetail}`, payload);
export const getVendors = () => sendGet('/vendors');
export const requestShipNow = (idOrderDetail: number) => sendPost(`/order/${idOrderDetail}/ship-now`);
export const getOrderShoppingStatistic = () => sendGet('/order/shopping-statistic');
export const getListOrderShopping = (filter: any) => sendGet('/order/shoppings', filter);
export const createdFirstPayment = (idOrderDetail: any, payload: any) =>
  sendPost(`/payment/${idOrderDetail}/pay-for-goods`, payload);
export const createdPayment2 = (idOrderDetail: any, payload: any) =>
  sendPost(`/payment/${idOrderDetail}/pay-for-delivery-shopping`, payload);
export const paymentInvoiceIncurred = (idOrderDetail: any, payload: any) =>
  sendPost(`/payment/${idOrderDetail}/pay-for-additional-shopping`, payload);
export const getDetailShopping = (idOrderDetail: any) => sendGet(`/order/${idOrderDetail}/detail-shopping`);
export const draftShopping = (payload: any) => sendPost(`/order-draft/shopping`, payload);
